import splitItemStyles from './split-items';